import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

import { ICategory } from '../../../../interfaces';

export default function useCategoryForm(
    onSubmit: (category: ICategory) => Promise<void>,
    category: ICategory | undefined
) {
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);

    const handleSubmitForm: SubmitHandler<ICategory> = async (data) => {
        try {
            setIsSubmiting(true);
            await onSubmit(data);
        } finally {
            setIsSubmiting(false);
        }
    };

    const {
        handleSubmit,
        formState: { errors },
        control,
        reset,
    } = useForm<ICategory>({
        defaultValues: {
            name: category?.name || '',
            description: category?.description || '',
        },
    });

    useEffect(() => {
        if (category) {
            reset({
                name: category.name || '',
                description: category.description || '',
            });
        }
    }, [category, reset]);

    return {
        handleSubmitForm,
        handleSubmit,
        control,
        isSubmiting,
        errors,
    };
}